if (!customElements.get('collection-result-count')) {
  class CollectionResultCount extends HTMLElement {
    constructor() {
      super();

      this.handleUpdateCollectionCountRef =
        this.handleUpdateCollectionCount.bind(this);
    }

    handleUpdateCollectionCount(event) {
      if (!event.detail.count) return;

      let text =
        event.detail.count == 1
          ? this.getAttribute('data-collection-text-one')
          : this.getAttribute('data-collection-text-other');
      text = text.replace(/{{ count }}/g, event.detail.count);

      this.querySelectorAll('[data-text-target').forEach((element) => {
        element.innerText = text;
      });
    }

    disconnectedCallback() {
      document.removeEventListener(
        'exo:update-collection-count',
        this.handleUpdateCollectionCountRef,
      );
    }

    connectedCallback() {
      document.addEventListener(
        'exo:update-collection-count',
        this.handleUpdateCollectionCountRef,
      );
    }
  }

  customElements.define('collection-result-count', CollectionResultCount);
}
